import get from 'lodash.get';

const getCurrentPackage = (rootState) => get(rootState, 'subscriptions.currentPackage', null);

export default getCurrentPackage;
